import { actionTypes } from "app/store/modules/actions/team.actions";

const initialState = {
  members: [],
  invites: [],
  roles: [],
  activity: [],
  sessions: {},
  loading: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TEAM_LOADING:
      return { ...state, loading: action.payload };
    case actionTypes.MEMBERS_LOADED:
      return { ...state, members: action.payload };
    case actionTypes.INVITES_LOADED:
      return { ...state, invites: action.payload };
    case actionTypes.ROLES_LOADED:
      return { ...state, roles: action.payload };
    case actionTypes.ACTIVITY_LOADED:
      return { ...state, activity: action.payload };
    case actionTypes.SESSIONS_LOADED:
      return {
        ...state,
        sessions: { ...state.sessions, [action.payload.membershipId]: action.payload.sessions },
      };
    default:
      return state;
  }
};
